<template>
  <v-card class="pa-4">
    <v-row dense>
      <v-card-title>
        {{ `Participante: ${dadoRelatorio.transferido ? dadoRelatorio.transferido : dadoRelatorio.origem}` }}
      </v-card-title>

      <v-spacer />

      <v-card-title v-if="dadoRelatorio.transferido">{{ `Transferido por: ${dadoRelatorio.origem}` }}</v-card-title>
    </v-row>
    <v-row dense class="mt-6">
      <strong>Entrada: </strong>
      <div class="ml-2">{{ formatDate(dadoRelatorio.dataAtdCall) }}</div>

      <v-spacer />

      <strong>Saída: </strong>
      <div class="ml-2 mr-4">{{ formatDate(dadoRelatorio.dateEndCall) }}</div>

      <v-spacer />

      <strong>Duração: </strong>
      <div class="ml-2 mr-4">{{ calculaTempoNaConferencia(dadoRelatorio.dataAtdCall, dadoRelatorio.dateEndCall) }}</div>
    </v-row>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    dadoRelatorio: Object,
  },

  methods: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
    },

    calculaTempoNaConferencia(dataInicio, dataFim) {
      const initialDate = moment(dataInicio, 'YYYY-MM-DD HH:mm:ss')
      const finalDate = moment(dataFim, 'YYYY-MM-DD HH:mm:ss')

      let tempoTotal = moment(finalDate).diff(moment(initialDate))
      let stringTempo = `${moment.utc(tempoTotal).format('HH:mm:ss')}`

      if (stringTempo === '23:59:59') {
        stringTempo = '+24:00:00'
      }

      return stringTempo
    },
  },
}
</script>
